import React from "react";

//should not work on web
export default () => {
	return null;
};
